export enum StatusCode {
	OK = 0,
	ERROR = 1
}